<template>
    <section>
        <app-header></app-header>
        <div>
            <section class="home-banner inner-banner">
                <div class="container-lg position-relative">
                    <h2 class="font-bold page-title text-center">{{ productInfo.store }}</h2> <img
                        src="/assets/custom/img/bottle-n-leaf.png" width="440" height="339" class="bnr-organic-left">
                    <img src="/assets/custom/img/sunflower-organic.png" width="440" height="339"
                        class="bnr-organic-right">
                </div>
                <div class="wall"></div> <img src="/assets/custom/img/assets.png" width="440" height="339"
                    class="assets">
            </section>

            <section class="category-description">
                <div class="container-lg">
                    <div class="box p-0 shadow">
                        <div class="row no-gutters">
                            <div class="col-lg-5"><img :src="'/img/product/' + productInfo.banner" width="520"
                                    height="272" class="bnr-organic-right w-100 h-auto"></div>
                            <div class="col-lg-7">
                                <div class="h-100 p-4 bg-white">
                                    <div class="h2 font-bold text-green">{{ productInfo.name }}</div>
                                    <div class="h5 text-dark font-medium pb-4">{{ productInfo.sub_header }}</div>
                                    <div v-html="productInfo.short_description"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="cms">
                <div class="container-lg">
                    <div v-html="productInfo.description"></div>
                    <div class="row align-items-center border-bottom py-5">
                        <div class="col-md-6 py-0 ">
                            <div class="pack-booking p-4  bg-green py-5 ">
                                <div class="row align-items-center ">
                                    <div class="col-sm-7 py-0">
                                        <h5 class="py-0 font-normal text-green">Available bulk packing</h5>
                                        <div class="h3 font-bold mb-0 pb-0">

                                        </div>
                                    </div>
                                    <div class="col-sm-5 py-0">
                                        <div class="load text-center"><a href="javascript:void(0)"
                                                class="load-all-btn"><span>Shop now</span> <i
                                                    class="las la-angle-right"></i></a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!---->
                    </div>
                </div>
            </section>

            <section class="org-product-info position-relative">
                <div class="wall"></div>
                <div class="container-lg">
                    <div class="box text-center text-light"><img src="/assets/custom/img/pathri.png"
                            data-src="/assets/custom/img/pathri.png" alt="leaf" class="vector-top2"> <img
                            src="/assets/custom/img/leaf-2.png" data-src="/assets/custom/img/leaf-2.png" alt="leaf"
                            class="vector-top">
                        <h3 class="font-bold">
                            With a rising demand in the world for pesticide-free and GMO-free
                            pure natural food products, MRT was among the first to take up the
                            initiative of organic methods of cultivation through its group of
                            farmers.
                        </h3>
                        <div class="icon mx-auto my-3"><img src="/assets/custom/img/icon-leaf.png"
                                data-src="/assets/custom/img/icon-leaf.png" alt="leaf" width="48" height="54"></div>
                        <p>
                            We have farmers growing, rarest and finest spices, herbs and various
                            other crops in the majestic valleys of Kashmir that are located at
                            an altitude of about 10,000 ft to the foothills of the mystic
                            mountains of western ghats, which is well known for its biological
                            diversity and endemism. Our organic range of product includes
                            Spices, Herbs, Essential oils, Ayurvedic Oils, Herbs &amp; Herbal
                            Powders, Glycerin, Vegetable Oils, Ghee&amp; Honey, Organic Foods,
                            Herbal Extracts, C02 Extracts, Floral Waters, Butters &amp; Waxes
                            etc.
                        </p> <img src="/assets/custom/img/vector2.png" data-src="/assets/custom/img/vector2.png"
                            alt="leaf" class="vector1"> <img src="/assets/custom/img/vector3.png"
                            data-src="/assets/custom/img/vector3.png" alt="leaf" class="vector2">
                    </div>
                </div>
            </section>

            <app-certification />
        </div>
        <app-footer></app-footer>
    </section>
</template>

<script>
import Header from './header.vue';
import Footer from './footer.vue';
import Certification from './index/Certification.vue';
import CommonMixin from "../mixins/CommonMixin";
export default {
    mixins: [CommonMixin],
    data() {
        return {
            productSlug: ''
        };
    },
    mounted() {
        this.productSlug = this.$route.params.slug;
        this.getProductBySlug(this.productSlug);
    },
    components: {
        "app-header": Header,
        "app-footer": Footer,
        "app-certification": Certification
    }
}
</script>

